export default __webpack_public_path__ + "static/media/img-0099-china-half-face.44f7baa3.png";